import request from ".";

export const officesApi = {
  getOffice: (office: string) =>
    request.post(`Offices/getOfficesByUrl?UniqueUrl=${office}`),
};
